import { BellFilled, BellOutlined } from "@ant-design/icons";
import { Modal, Typography } from "antd";
import { useState } from "react";
import SelectAlarmWays from "./AlarmWays";
import { useQueryClient } from "react-query";
import endPoints from "apps/CustomerPanel/Alarm/EndPoints"
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "apps/RealState/Details/ServerSideStates";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import advertDetailsEndPonints from "apps/RealState/Details/EndPoints"

const AlarmButton = () => {
  const { Text } = Typography;
  const [isShowAlarmModal, setIsShowAlarmModal] = useState(false);
  const queryClient = useQueryClient()
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
   const [searchParams] = useSearchParams();
    const advertId = searchParams.get("id");
    const advertDetails = useGetAdvertDetails(advertId);
    const advertData = advertDetails?.data?.data;

  return (
    <>
      <span
        className="hover:cursor-pointer !flex gap-1 !p-2  !rounded-md transition"
        onClick={() => {
          if(userInfoes?.id)
          {
            if(advertData?.isAlarm)
            {
              openNotificationWithIcon("default","Bu ilan alarma eklenmiş")
            }
            else{
  
              setIsShowAlarmModal(true);
            }

          }
          else{
            openNotificationWithIcon("default","İlanı alarma eklemek için giriş yapınız")
          }
        }}
      >
        {advertData?.isAlarm ? (
          <>
             <BellFilled className="!text-xs !text-red-500 " />
            <Text className="!text-xs">Alarmda</Text>
          </>
        ) : (
          <>
           <BellOutlined className="!text-xs !text-red-500 " />
           <Text className="!text-xs">Alarm</Text>
          </>
        )}

        
      </span>
      <Modal
        open={isShowAlarmModal}
        onCancel={() => {
          setIsShowAlarmModal(false);
        }}
        footer={false}
        title={"Alarm Yolu Seç"}
      >
        <SelectAlarmWays 
        onFinish={()=>{
          queryClient.resetQueries({
            queryKey: endPoints.getAlarmList,
            exact: false,
          });
          queryClient.resetQueries({
            queryKey: advertDetailsEndPonints.getAdvertDetails,
            exact: false,
          });
          setIsShowAlarmModal(false);
        }}
        />
      </Modal>
    </>
  );
};

export default AlarmButton;
